module.exports = __webpack_public_path__ + "img/exams.77c8f82d.png";